var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Circle, Rect, Defs, ClipPath } from "react-native-svg";
var SvgFlagTr = function SvgFlagTr(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    fill: "none",
    viewBox: "0 0 20 14"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#flag-tr_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#E30A17",
    d: "M0 0h20v14H0z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 7.5,
    cy: 7,
    r: 3.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 8.4,
    cy: 7,
    r: 2.8,
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "m12.3 5.3.4 1.15 1.217.025-.97.735.352 1.165-.999-.695-1 .695.353-1.165-.97-.735L11.9 6.45z"
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 19.5,
    height: 13.5,
    x: 0.25,
    y: 0.25,
    stroke: "#000",
    strokeOpacity: 0.25,
    strokeWidth: 0.5,
    rx: 1.75
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "flag-tr_svg__a"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 20,
    height: 14,
    fill: "#fff",
    rx: 2
  })))));
};
export default SvgFlagTr;